import { dispatch } from 'nike-re-framejs';

import ObjectValues from '@/common/ObjectValues';
import * as routes from '@/routing/routes';
import './handlers';
import './history';
import { NavigateNikeRoute, NikeRoute, RouteParams, SearchParams } from 'nike-ui/src/common/routing/types';
import { History } from 'history';

export function navigate(
    route: NavigateNikeRoute,
    params?: RouteParams,
    searchParams?: SearchParams,
    state?: History.LocationState,
    allowReplace?: boolean
) {
    dispatch(['navigate', route, params, searchParams, state, allowReplace]);
}

export function pageReplace(route: NavigateNikeRoute, params?: RouteParams, state?: History.LocationState) {
    dispatch(['page_replace', route, params, state]);
}

export function updateURLSearchParams(
    searchParams: SearchParams,
    state?: History.LocationState,
    replace: boolean = false
) {
    dispatch(['page_change_param', searchParams, state, replace]);
}

export function history_back(defaultRoute?: NikeRoute, params?: RouteParams) {
    return dispatch(['history_back', defaultRoute, params]);
}

export function getRouteByName(name) {
    return ObjectValues(routes).find(route => route.name === name);
}
